export default{
    tickets(state){
        return state.tickets;
    },

    pages(state){
        return state.pages;
    }
}